// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.third_AqCLW {
  width : 33.3333%;
  height : 100%;
}

.paginationInput_u5Vfs.lev-combobox.lev-combobox-paginationInput > .rw-widget-container > .rw-select.rw-select-bordered {
  width: 24px;
}

.filterCount_g_2G9 {
  background-color: var( --color-brand500 );
  border-radius: 50%;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-left: 8px;
}

.content_jI_wG {
  display: flex;
  align-items: center;
  overflow: visible !important;
}

.flex_hyyFD {
  width: 100%;
}

/* separator */
.paginationContainer_UVChQ {
  width:100%;
  height: 64px;
  padding-left: 16px;
  padding-right: 16px;
}

.pageSizeText_zZpVd {
  padding-left: 12px;
}

.leftArrow_0p8IL {
  padding-left: 2px !important;
  margin-right: 12px;
  cursor: pointer;
}

.rightArrow_OQiKj {
  padding-right: 2px !important;
  margin-left: 12px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-user-management/lib/TablePagination.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA,cAAc;AACd;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".third {\n  width : 33.3333%;\n  height : 100%;\n}\n\n.paginationInput:global( .lev-combobox.lev-combobox-paginationInput > .rw-widget-container > .rw-select.rw-select-bordered ) {\n  width: 24px;\n}\n\n.filterCount {\n  background-color: var( --color-brand500 );\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  margin-left: 8px;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  overflow: visible !important;\n}\n\n.flex {\n  width: 100%;\n}\n\n/* separator */\n.paginationContainer {\n  width:100%;\n  height: 64px;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.pageSizeText {\n  padding-left: 12px;\n}\n\n.leftArrow {\n  padding-left: 2px !important;\n  margin-right: 12px;\n  cursor: pointer;\n}\n\n.rightArrow {\n  padding-right: 2px !important;\n  margin-left: 12px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"third": `third_AqCLW`,
	"paginationInput": `paginationInput_u5Vfs`,
	"filterCount": `filterCount_g_2G9`,
	"content": `content_jI_wG`,
	"flex": `flex_hyyFD`,
	"paginationContainer": `paginationContainer_UVChQ`,
	"pageSizeText": `pageSizeText_zZpVd`,
	"leftArrow": `leftArrow_0p8IL`,
	"rightArrow": `rightArrow_OQiKj`
};
export default ___CSS_LOADER_EXPORT___;
